export const getAverageRating = ratings => {
  if (!ratings || !ratings.length) {
    return 5;
  }
  let total = 0;
  ratings.forEach(rating => {
    total = total + rating.rating;
  });

  return total / ratings.length;
};



// WEBPACK FOOTER //
// ./src/helpers/ratingsHelper.js